import { render } from "./PurchaseByProductReport.vue?vue&type=template&id=1184eb2f&scoped=true"
import script from "./PurchaseByProductReport.vue?vue&type=script&lang=js"
export * from "./PurchaseByProductReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=1184eb2f&scoped=true&lang=css&external"
import "./PurchaseByProductReport.vue?vue&type=style&index=1&id=1184eb2f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1184eb2f"]])

export default __exports__